export default "/weETHs.175ee766334ee2b7feafed957c0da24c.svg";